// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RMlUN","rightAdornment":"Header_rightAdornment__1H12L"};